export default __webpack_public_path__ + "static/media/history.fa2ae616.svg";